export const ORDER_STATUS = Object.freeze({
    NEW: "NEW",
    SENT: "SENT",
    INVOICED: "INVOICED",
    CANCELLED: "CANCELLED",
});

export const ORDER_STATUS_CONFIG = Object.freeze({
    [ORDER_STATUS.NEW]: {label: "Ny", color: "warning"},
    [ORDER_STATUS.SENT]: {label: "Sendt", color: "info"},
    [ORDER_STATUS.INVOICED]: {label: "Fakturert", color: "success"},
    [ORDER_STATUS.CANCELLED]: {label: "Kansellert", color: "default"},
});

export const normalizeOrderStatus = (status) => {
    if (!status || typeof status !== "string") {
        return ORDER_STATUS.NEW;
    }
    const upper = status.trim().toUpperCase();
    if (upper === "PROCESSED") {
        return ORDER_STATUS.SENT;
    }
    return ORDER_STATUS_CONFIG[upper] ? upper : ORDER_STATUS.NEW;
};

export const calculateOrderKPIs = (orders) => {
    if (!Array.isArray(orders)) {
        return {totalOrders: 0, newOrders: 0, totalBooks: 0};
    }

    let newOrders = 0;
    let totalBooks = 0;

    for (const order of orders) {
        const norm = normalizeOrderStatus(order?.status);
        if (norm === ORDER_STATUS.NEW) {
            newOrders += 1;
        }
        if (norm !== ORDER_STATUS.CANCELLED) {
            const count = Number(order?.numberOfBooks);
            if (!Number.isNaN(count) && count > 0) {
                totalBooks += count;
            }
        }
    }

    return {
        totalOrders: orders.length,
        newOrders,
        totalBooks,
    };
};

export const filterBookOrders = (orders, {statusFilter = "ALL", searchQuery = ""} = {}) => {
    if (!Array.isArray(orders)) {
        return [];
    }

    const query = searchQuery ? searchQuery.trim().toLowerCase() : "";

    return orders.filter((order) => {
        if (!order) return false;

        const currentStatus = normalizeOrderStatus(order.status);
        if (statusFilter && statusFilter !== "ALL" && currentStatus !== statusFilter) {
            return false;
        }

        if (query) {
            const searchTargets = [
                order.name,
                order.email,
                order.delivery?.name,
                order.delivery?.place,
                order.invoice?.name,
                order.invoice?.orgNumber,
            ];

            const matches = searchTargets.some(
                (field) => typeof field === "string" && field.toLowerCase().includes(query)
            );

            if (!matches) {
                return false;
            }
        }

        return true;
    });
};

const pad2 = (n) => String(n).padStart(2, "0");

export const formatOrderDate = (timestamp) => {
    if (!timestamp) return "—";

    let date = null;
    if (typeof timestamp.toDate === "function") {
        date = timestamp.toDate();
    } else if (typeof timestamp.seconds === "number") {
        date = new Date(timestamp.seconds * 1000);
    } else if (timestamp instanceof Date) {
        date = timestamp;
    } else {
        date = new Date(timestamp);
    }

    if (!date || Number.isNaN(date.getTime())) {
        return "—";
    }

    const day = pad2(date.getDate());
    const month = pad2(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad2(date.getHours());
    const minutes = pad2(date.getMinutes());

    return `${day}.${month}.${year} kl. ${hours}:${minutes}`;
};

export const safeField = (val, fallback = "—") => {
    if (val === null || val === undefined) return fallback;
    const str = String(val).trim();
    return str.length > 0 ? str : fallback;
};
